import React from 'react';
import styled from '@emotion/styled';
import type { OverflowProps, WidthProps } from 'styled-system';
import { overflow, width } from 'styled-system';

import type { ReclamationOrder } from 'common/types/reclamation';
import { useLocalization } from '../../providers/LocaleProvider';
import { localizeDate } from '../../utils/date';
import { Flex } from '../Flex';
import { BodyRegularBR2 } from '../Typography';

interface OrderOverviewProps extends ReclamationOrder {
  isMarketplace: boolean;
  isExternalMarketplace?: boolean;
}

const EllipsisDetail = styled(BodyRegularBR2)<WidthProps & OverflowProps>`
  ${width};
  ${overflow};

  text-overflow: ellipsis;
  white-space: nowrap;
`;
const ellipsisDetailStyles = {
  width: ['140px', null, 'auto'],
  overflow: 'hidden',
};

const Label = styled(BodyRegularBR2)<WidthProps>`
  ${width};
`;

const OrderOverview = ({
  customerNumber,
  id,
  createdAt,
  isMarketplace,
  oms,
  isExternalMarketplace,
}: OrderOverviewProps) => {
  const orderNumber =
    isMarketplace && (oms?.tradebyte?.orderId || oms?.orderId)
      ? isExternalMarketplace
        ? oms.tradebyte.orderId
        : oms.orderId
      : id;
  const shopName = oms?.shop?.name;
  const { t, locale } = useLocalization();

  return (
    <Flex flex={1} flexDirection="column">
      {isMarketplace && shopName ? (
        <Flex>
          <Label width="50%">{t('h24_seller_label')}:</Label>
          <EllipsisDetail {...ellipsisDetailStyles}>{shopName}</EllipsisDetail>
        </Flex>
      ) : null}

      <Flex>
        <Label width="50%">{t('h24_customer_number')}:</Label>
        <BodyRegularBR2>{customerNumber}</BodyRegularBR2>
      </Flex>

      <Flex>
        <Label width="50%">{t('h24_order_number')}:</Label>
        <BodyRegularBR2>{orderNumber}</BodyRegularBR2>
      </Flex>

      <Flex>
        <Label width="50%">{t('h24_order_date')}:</Label>
        <BodyRegularBR2>{localizeDate(createdAt, locale)}</BodyRegularBR2>
      </Flex>
    </Flex>
  );
};

export default OrderOverview;
